import gql from 'graphql-tag';

import dokkioTagSummaryFragment from '../fragments/dokkioTagSummaryFragment';

export default gql`
  query dokkioTagSummary($dokkioTagID: DokkioID!) {
    dokkioTagSummary(dokkioTagID: $dokkioTagID) {
      ...dokkioTagSummaryFragment
    }
  }
  ${dokkioTagSummaryFragment}
`;
